/**
 * @fileoverview Define the shared browser notification interface consumed by workspaces. `ToastProvider.js` owns delivery; callers own message meaning and the action/result that produced it. A toast is transient feedback rather than durable business or audit state.
 */

import React from 'react';

const ToastContext = React.createContext(null);

export default ToastContext;
